<template>
	<div id="LinkUnico">
		<v-container>

				<!-- //?ESTA PAGINA NAO ESTÁ MAIS EM USO. -->

			<!--//*Adicionar comentário -->
			<v-dialog v-model="modalComentario.enabled" max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">O que reprova nesta página?</span>
					</v-card-title>
					<v-card-text>
						<v-container grid-list-md>
							<v-layout wrap>
								<v-flex xs12>
									<v-textarea solo name="comment-input" v-model="comentario" label="Comentário"></v-textarea>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" flat @click="modalComentario.enabled = false">Cancelar</v-btn>
						<v-btn color="blue darken-1" flat @click="reprovarComentario(modalComentario.pagina, comentario)">Enviar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

      <div class="display-1">Aprovação de conteúdo do "{{sites.nome}}"</div>
      <v-list :key="key" v-for="(item, key) in sites.paginas">
        <v-card>
          <v-card-title>
            <div style="width: 100%">
              <span class="text-xs-left title" v-html="item.nome"/>
							<span v-if="item.situation == 'aguardando aprovação'" class="text-xs-right title situation r-border">ESPERANDO APROVAÇÃO</span>
							<span v-if="item.situation == 'aprovado' || item.situation == 'reprovado'" class="r-border text-xs-right title situation">{{item.situation}}</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-html="item.content"></div>
						<div>
							<v-btn color="success" @click="aprovar(key)">Aprovar</v-btn>
							<v-btn color="error" @click="reprovar(key)">Reprovar</v-btn>
						</div>
          </v-card-text>
        </v-card>
      </v-list>
			<v-snackbar color="secondary" v-model="alert.enabled" top :timeout=snackTime>
				<span dismissible="true">{{alert.content}}</span>
			</v-snackbar>
		</v-container>
	</div>
</template>

<script>
import { db } from '../firebase'

const sitesRef = db.ref('sites')

export default {
    name: 'LinkUnico',

		firebase(){
      const childRef = sitesRef.child(this.$route.query.siteId)
			return {
				sites: {
					source: childRef,
          asObject: true
				} 
			}
		},

    data () {
        return {
					sites: {},
          siteId: null,

					//*Alerta de aprovar ou reprovar
					snackTime: 2000,
					alert: {
						enabled: false,
						content: '',
					},

					//*Modal do comentário
					modalComentario: {
						enabled: false,
						pagina: null,
					}
    	}
		},
		methods: {
			aprovar(pagina) {
				sitesRef.child(this.$route.query.siteId + '/paginas/' + pagina).update({
					situation: 'aprovado'
				}).then(
					this.alert.enabled = true,
					this.alert.content = 'Aprovado!'
				)
			},
			reprovar(pagina) {
				this.modalComentario.enabled = true
				this.modalComentario.pagina = pagina
			},
			reprovarComentario(pagina, comentario) {
				sitesRef.child(this.$route.query.siteId + '/paginas/' + pagina).update({
					situation: 'reprovado',
					comentario: comentario
				}).then(
					this.alert.enabled = true,
					this.alert.content = 'Reprovado!',
					this.modalComentario.enabled = false
				)
			}
		}
}
</script>

<style lang="sass">
// *Style da Resultam
.situation
	float: right
	text-transform: uppercase
.r-border	
	border: 1px solid #333
	padding: 10px
	border-radius: 5px
// *Alterações de Style do Vuetify

</style>
